import { __decorate, __metadata } from "tslib";
import { Type } from 'class-transformer';
import { v4 as uuidv4 } from 'uuid';
import TemplateActivity from './templateActivity';
let TemplateStageModel = /** @class */ (() => {
    class TemplateStageModel {
        constructor() {
            this.id = uuidv4();
            this.stageName = '';
            this.isTenantVisible = true;
            this.description = '';
            this.displayOrder = null;
            this.activities = [];
        }
    }
    __decorate([
        Type(() => TemplateActivity),
        __metadata("design:type", Array)
    ], TemplateStageModel.prototype, "activities", void 0);
    return TemplateStageModel;
})();
export { TemplateStageModel };
export default class TemplateStage extends TemplateStageModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
    get activityCount() {
        return this.activities.length;
    }
    get hourCount() {
        return 0;
    }
}
